import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonSaveComponent } from "../../../button-save/button-save.component";
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { AccionesDialog } from '@models/base/identificadores.model';

@Component({
  selector: 'app-dialog-repeat-event',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatDatepickerModule, MatNativeDateModule, MatInputModule, MatButtonModule, MatSelectModule, MatCheckboxModule, CommonModule,
    ReactiveFormsModule, ButtonSaveComponent, ButtonCloseDialogComponent,ButtonCancelDialogComponent,ButtonDeleteComponent],
  templateUrl: './dialog-repeat-event.component.html',
  styleUrl: './dialog-repeat-event.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogRepeatEventComponent {
  selectedDays: string[] = []; form!: FormGroup;
  daysOfWeek = [
    { label: 'L', value: 'L' },
    { label: 'M', value: 'M' },
    { label: 'X', value: 'X' },
    { label: 'J', value: 'J' },
    { label: 'V', value: 'V' },
    { label: 'S', value: 'S' },
    { label: 'D', value: 'D' }
  ];

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogRepeatEventComponent>,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      startDate: [new Date()],
      repeatEvery: [1],
      repeatUnit: ['dia'],
      selectedDays: [[]],
      endDate: [new Date()]
    });

    this.form.get('repeatUnit')?.valueChanges.subscribe(unit => {
      this.updateDaysSelection(unit);
    });

    // Evaluar valor inicial al cargar el componente
    const initialUnit = this.form.get('repeatUnit')?.value;
    this.updateDaysSelection(initialUnit);
  }

  updateDaysSelection(unit: string): void {
    if (unit === 'dia') {
      this.selectedDays = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
    } else if (this.selectedDays.length === 7) {
      // Si antes estaba en "día", podés limpiar si lo necesitás
      this.selectedDays = [];
    }
  }

  // toggleDay(day: string): void {
  //   const currentDays = this.form.value.selectedDays;
  //   if (currentDays.includes(day)) {
  //     this.form.patchValue({
  //       selectedDays: currentDays.filter((d: string) => d !== day)
  //     });
  //   } else {
  //     this.form.patchValue({
  //       selectedDays: [...currentDays, day]
  //     });
  //   }
  // }

  isSelected(day: string): boolean {
    return this.selectedDays.includes(day);
  }

  toggleDay(day: string): void {
    const index = this.selectedDays.indexOf(day);
    if (index > -1) {
      this.selectedDays.splice(index, 1);
    } else {
      this.selectedDays.push(day);
    }
  }

  removeEndDate(): void {
    this.form.patchValue({ endDate: null });
  }

  save(): void {
    console.log('✅ Form Data:', this.form.value);
    this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.form.value  });
  }

  discard(): void {
    // Lógica para cancelar
  }

  eliminar(): void {
    this.dialogRef.close({ event: AccionesDialog.Agregar, data: null  });
  }
}
